document.addEventListener("DOMContentLoaded", function () {
  let currentVariantId = "";
  let currentBasePrice = 0;
  let currentBaseComparePrice = 0;

  function setInitialVariantData() {
    const variantSelect = document.getElementById("variant-select");
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    const price = selectedOption.getAttribute("data-price");
    const comparePrice = selectedOption.getAttribute("data-compare-price");

    currentVariantId = selectedOption.value;
    currentBasePrice = price ? Math.round(parseInt(price) / 100) : 0;
    currentBaseComparePrice = comparePrice
      ? Math.round(parseInt(comparePrice) / 100)
      : 0;

    // Add to cart button (mobile) initial price
    let initialRegularPrice = $(
      ".product__info-container .has-additional-product .price__regular .price-item--regular"
    )
      .text()
      .trim();
    let initialSalePrice = $(
      ".product__info-container .has-additional-product .price__sale .price-item--sale"
    )
      .text()
      .trim();
    const initialPrice =
      initialRegularPrice == initialSalePrice
        ? initialRegularPrice
        : initialSalePrice;

    $(".product-form__submit .total-price").text(`(${initialPrice})`);
  }

  // Stem count option price changes
  // function stemCountPriceUpdate(basePrice = null, baseComparePrice = null) {
  //   const variantAddonSelect = $('select[name="options[Add-on/s]"]');
  //   const variantStemSelect =
  //     $('select[name="options[Stem Count]"]') ||
  //     $('select[name="options["SELECT SIZE OPTION]"]');
  //   const variantAddonPrice = variantAddonSelect
  //     ?.find("option:selected")
  //     .data("variantAddonPrice");
  //   let subtractedPrice = 0;

  //   if (basePrice != null && baseComparePrice != null) {
  //     if (baseComparePrice > basePrice) {
  //       subtractedPrice = baseComparePrice - variantAddonPrice;
  //     } else {
  //       subtractedPrice = basePrice - variantAddonPrice;
  //     }
  //   } else {
  //     const initialBasePrice = parseInt(
  //       document
  //         .querySelector(
  //           ".product__info-container .has-additional-product .price__sale .price-item--sale"
  //         )
  //         .textContent.replace(/[^0-9.]/g, "")
  //     );
  //     subtractedPrice = initialBasePrice - variantAddonPrice;
  //   }
  //   variantStemSelect
  //     .find("option:selected .option-price")
  //     .text("($" + subtractedPrice + ")");
  // }

  setInitialVariantData();
  // stemCountPriceUpdate();

  function updatePrice(price, compareAtPrice) {
    const priceValue = price ? parseInt(price.replace(/[^0-9.]/g, "")) : 0;
    const compareAtPriceValue = compareAtPrice
      ? parseInt(compareAtPrice.replace(/[^0-9.]/g, ""))
      : 0;
    const btnTotalPrice = $(".product-form__submit .total-price");
    if (compareAtPrice && compareAtPriceValue > priceValue) {
      const salePriceElement = document.querySelector(
        ".product__info-container .has-additional-product .price__sale .price-item--sale"
      );
      const regularPriceElement = document.querySelector(
        ".product__info-container .has-additional-product .price__sale .price-item--regular"
      );
      if (salePriceElement && price) {
        salePriceElement.textContent = price;
      }
      if (regularPriceElement && compareAtPrice) {
        regularPriceElement.textContent = compareAtPrice;
      }
    } else {
      const regularPriceElement = document.querySelector(
        ".product__info-container .has-additional-product .price__regular .price-item--regular"
      );
      if (regularPriceElement && price) {
        regularPriceElement.textContent = price;
      }
    }
    btnTotalPrice.text(`(${price.replace(/ /g, "")})`);
  }

  function getStemQuantity() {
    const quantityInput = document.getElementById("extra-stem-quantity");
    return quantityInput ? parseInt(quantityInput.value) || 0 : 0;
  }

  function updateRibbonHiddenInput() {
    const hiddenInputs = document.querySelector(".hidden-inputs-wrapper");
    const ribbonSelected = !!document.querySelector(
      'input[name="custom_ribbon"]:checked'
    );
    const stemPropsEl = hiddenInputs.querySelector("#extra_stem_props");
    const currentStemQty = getStemQuantity();
    const dataStem =
      stemPropsEl && stemPropsEl.getAttribute("data-stem")
        ? stemPropsEl.getAttribute("data-stem")
        : currentStemQty;

    if (ribbonSelected) {
      hiddenInputs.innerHTML = `<input type="hidden" id="extra_stem_props" name="properties[Bundle ID]" data-stem="${dataStem}" value="${currentVariantId}">`;
    } else {
      if (currentStemQty === 0) {
        hiddenInputs.innerHTML = "";
      }
    }
  }

  function calculateCombinedPrice() {
    const quantityInput = document.getElementById("extra-stem-quantity");
    const extraProductSelect = document.querySelector(
      ".select__select.extra_product"
    );
    const customGoldRibbon = document.querySelector(
      'input[name="custom_ribbon"]:checked'
    );
    const checkedRadioVase = document.querySelector("[name=optradio]:checked");
    // const checkedRadioBreath = document.querySelector(
    //   "[name=optradiobreath]:checked"
    // );
    // const checkedRadioVase = document.querySelector("[name=optradio]");
    const checkedRadioBreath = document.querySelector("[name=optradiobreath]");
    let basePrice = currentBasePrice;
    let baseComparePrice = currentBaseComparePrice;
    let extraPrice = 0;
    let customGoldPrice = 0;
    let radioPrice = 0;
    let stemPrice = 0;
    let perStemPrice =
      document
        .getElementById("extra-stem-quantity")
        ?.getAttribute("data-price") ?? 0;
    // Add champagne
    if (extraProductSelect && extraProductSelect.selectedIndex >= 0) {
      const selectedExtraOption =
        extraProductSelect.options[extraProductSelect.selectedIndex];
      const extraProductPrice = selectedExtraOption.getAttribute("data-price");
      if (extraProductPrice) {
        extraPrice = parseInt(extraProductPrice) || 0;
      }
    }
    // Add Custom gold ribbon
    if (customGoldRibbon) {
      const extraProductPrice = customGoldRibbon.getAttribute("data-price");
      if (extraProductPrice) {
        customGoldPrice = parseInt(extraProductPrice) || 0;
      }
    }
    // Popular Add-ons
    // if (checkedRadioVase) {
    //   const radioPriceValue = checkedRadioVase.getAttribute("data-price");
    //   if (radioPriceValue) {
    //     radioPrice += parseInt(radioPriceValue) || 0;
    //   }
    // }
    // if (checkedRadioBreath) {
    //   const radioBreathPriceValue =
    //     checkedRadioBreath.getAttribute("data-price");
    //   if (radioBreathPriceValue) {
    //     radioPrice += parseInt(radioBreathPriceValue) || 0;
    //   }
    // }
    // VASE SELECT
    if (checkedRadioVase) {
      // const selectedVaseOption = checkedRadioVase.options[checkedRadioVase.selectedIndex];
      // const radioPriceValue = selectedVaseOption.getAttribute("data-price");
      const radioPriceValue = checkedRadioVase.getAttribute("data-price");

      if (radioPriceValue) {
        radioPrice += parseInt(radioPriceValue) || 0;
      }
    }

    // BABY'S BREATH SELECT
    if (checkedRadioBreath) {
      const selectedBreathOption =
        checkedRadioBreath.options[checkedRadioBreath.selectedIndex];
      const radioBreathPriceValue =
        selectedBreathOption.getAttribute("data-price");

      if (radioBreathPriceValue) {
        radioPrice += parseInt(radioBreathPriceValue) || 0;
      }
    }

    //Extra stems
    if (quantityInput) {
      const stemQuantity = parseInt(quantityInput.value) || 0;
      stemPrice = stemQuantity * parseFloat(perStemPrice);
    }

    const combinedPrice =
      basePrice + extraPrice + customGoldPrice + radioPrice + stemPrice;

    let formattedComparePrice = null;
    if (baseComparePrice > 0) {
      const combinedComparePrice =
        baseComparePrice +
        extraPrice +
        customGoldPrice +
        radioPrice +
        stemPrice;
      formattedComparePrice = "$" + combinedComparePrice.toLocaleString();
    }
    const formattedPrice = "$" + combinedPrice.toLocaleString();

    return {
      price: formattedPrice,
      comparePrice: formattedComparePrice,
    };
  }

  function syncPriceWithSelections() {
    const combinedPrices = calculateCombinedPrice();
    updatePrice(combinedPrices.price, combinedPrices.comparePrice);
    resetAddtoCart();
    sessionStorage.setItem("vase_added", "");
  }

  function handleExtraStemQuantity() {
    const quantityInput = document.getElementById("extra-stem-quantity");
    const incrementBtn = document.querySelector(".extra-stem-increment");
    const decrementBtn = document.querySelector(".extra-stem-decrement");
    const hiddenInputs = document.querySelector(".hidden-inputs-wrapper");
    if (!quantityInput || !incrementBtn || !decrementBtn || !hiddenInputs) {
      return;
    }
    function updateHiddenInput() {
      const currentValue = parseInt(quantityInput.value);
      if (currentValue > 0) {
        hiddenInputs.innerHTML = `
          <input type="hidden" id="extra_stem_props" name="properties[Bundle ID]" data-stem="${quantityInput.value}" value="${currentVariantId}" >
        `;
      } else {
        hiddenInputs.innerHTML = "";
      }
      updateRibbonHiddenInput();
    }
    incrementBtn.addEventListener("click", () => {
      const currentValue = parseInt(quantityInput.value);
      if (currentValue < 10) {
        quantityInput.value = currentValue + 1;
        updateHiddenInput();
        syncPriceWithSelections();
      }
    });
    decrementBtn.addEventListener("click", () => {
      const currentValue = parseInt(quantityInput.value);
      if (currentValue > 0) {
        quantityInput.value = currentValue - 1;
        updateHiddenInput();
        syncPriceWithSelections();
      }
    });
  }

  function additionalProduct() {
    const extraProductSelect = document.querySelector(
      ".select__select.extra_product"
    );
    // Extra stems
    handleExtraStemQuantity();
    // Default variant
    document.addEventListener("variant:change", (event) => {
      const variantId = event.detail.id;
      const variantSelect = document.getElementById("variant-select");
      if (variantSelect) {
        const matchingOption = variantSelect.querySelector(
          `option[value="${variantId}"]`
        );
        if (matchingOption) {
          const priceInfo = matchingOption.getAttribute("data-price-info");
          const metaTextElement = document.querySelector(
            ".product__info-container .has-additional-product .meta-text"
          );
          if (metaTextElement && priceInfo && priceInfo.trim() !== "") {
            metaTextElement.textContent = priceInfo;
          }
        }
      }
      currentVariantId = event.detail.id;
      currentBasePrice = event.detail.price
        ? Math.round(event.detail.price / 100)
        : 0;
      currentBaseComparePrice = event.detail.compare_at_price
        ? Math.round(event.detail.compare_at_price / 100)
        : 0;

      // stemCountPriceUpdate(currentBasePrice, currentBaseComparePrice);

      const priceElement = document.querySelector(
        ".product__info-container .has-additional-product .price--large"
      );
      if (priceElement) {
        if (!event.detail.available) {
          priceElement.classList.add("price--sold-out");
        } else {
          priceElement.classList.remove("price--sold-out");
        }

        if (
          event.detail.compare_at_price &&
          event.detail.price &&
          event.detail.compare_at_price > event.detail.price
        ) {
          priceElement.classList.add("price--on-sale");
        } else {
          priceElement.classList.remove("price--on-sale");
        }
      }
      const combinedPrices = calculateCombinedPrice();
      updatePrice(combinedPrices.price, combinedPrices.comparePrice);
      sessionStorage.setItem("vase_added", "");
    });
    // Add champagne
    if (extraProductSelect) {
      extraProductSelect.addEventListener("change", syncPriceWithSelections);
    }
    // Popular Add-ons
    const radioButtons = document.querySelectorAll(
      "[name=optradio], [name=optradiobreath], [name=custom_ribbon]"
    );
    radioButtons.forEach(function (radio) {
      radio.addEventListener("click", (e) => {
        syncPriceWithSelections();
        if (e.target && e.target.name === "custom_ribbon") {
          updateRibbonHiddenInput();
        }
      });
    });
    updateRibbonHiddenInput();
  }
  additionalProduct();
  window.calculateCombinedPrice = calculateCombinedPrice;
  window.updatePrice = updatePrice;
});
